import { TreeViewBaseItem } from "@mui/x-tree-view/models";

import { MapEditorFeatureCreateOptionsSelect_ObservationFragment } from "../../fragments.generated";

/**
 * Converts research types array into TreeViewBaseItem structure
 */
export function mapToTreeNodes(
    researchTypes: MapEditorFeatureCreateOptionsSelect_ObservationFragment[],
): TreeViewBaseItem[] {
    return researchTypes.map(researchType => ({
        id: researchType.id,
        label: researchType.name,
        children: researchType.observationTypes
            .slice()
            .sort((a, b) => a.order - b.order)
            .map(observationType => ({
                id: observationType.id,
                label: observationType.name,
            })),
    }));
}

/**
 * Returns IDs to auto-expand if there's only one item
 */
export function getAutoExpandedItems(items: TreeViewBaseItem[]): string[] {
    return items.length === 1 ? [items[0].id] : [];
}
